import { AfterViewInit, Component, OnInit } from '@angular/core';
import { AbstractCallComponent } from '../abstract-call/abstract-call.component';
import { modelServiceJsonToIntegrationStoreData } from '../../routines';

@Component({
    selector: 'se-array-find-call',
    templateUrl: './array-find-call.component.html',
    styleUrls: ['./array-find-call.component.scss'],
})
export class ArrayFindCallComponent extends AbstractCallComponent implements OnInit, AfterViewInit {
    constructor() {
        super();
    }

    ngOnInit(): void {
        super.ngOnInit();
        this.callInit();
    }

    ngAfterViewInit(): void {
        console.log('after view init array-find-call');
    }

    protected async run(): Promise<any> {
        const parsedCall = this.parseAllSourceWithDataStore(this.call);

        if (!parsedCall.findConfig) {
            this.callThrowError.emit('findConfig is required in call configuration');
            return;
        }

        const { keyPathToSearch, valueToMatch, arrayToSearchIn } = parsedCall.findConfig;

        if (this.debug) {
            console.log('INTEGRATIONS arrayFind run()', { parsedCall });
        }

        if (!Array.isArray(arrayToSearchIn)) {
            this.callThrowError.emit(this.call.errorHandling?.action);
            //throw new Error('arrayToSearchIn must be an array');
            return Promise.reject('arrayToSearchIn must be an array');
        } else {
            const valueFound =
                arrayToSearchIn.find((entry) =>
                    keyPathToSearch ? entry[keyPathToSearch] == valueToMatch : entry == valueToMatch,
                ) ?? null;

            if (this.debug) {
                console.log('INTEGRATIONS arrayFind run()', { valueFound });
            }

            return Promise.resolve(valueFound);
        }
    }

    protected end() {

        /*gestione errorHandling* */
        const path = this.call.errorHandling?.path || '';
        let value;
        //usare isPrimitiveType() ?
        if (typeof this.result !== 'object' && !Array.isArray(this.result)) value = this.result;
        else {
            value = modelServiceJsonToIntegrationStoreData(this.result);
        }


        const message = this.call.errorHandling?.message ? '' : 'No result found';

        if (this.errorValueHandler(value)) {
            this.callThrowError.emit(message);
        } else {
            super.end();
        }
    }
}
